var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthDriver } from './drivers/default/enums/authDriver';
import { HttpClient } from './httpClient';
import axios from 'axios';
export class Orion {
    static init(host, prefix = 'api', authDriver = AuthDriver.Default, token) {
        Orion.setHost(host);
        if (token) {
            Orion.setToken(token);
        }
        this.prefix = prefix;
        this.authDriver = authDriver;
        this.httpClientConfig = Orion.buildHttpClientConfig();
    }
    static setHost(apiUrl) {
        Orion.host = apiUrl;
        return Orion;
    }
    static getHost() {
        return Orion.host.endsWith('/') ? Orion.host : `${Orion.host}/`;
    }
    static setPrefix(prefix) {
        Orion.prefix = prefix;
        return Orion;
    }
    static getPrefix() {
        return Orion.prefix;
    }
    static setAuthDriver(authDriver) {
        this.authDriver = authDriver;
        Orion.httpClientConfig = Orion.buildHttpClientConfig();
        return Orion;
    }
    static getAuthDriver() {
        return this.authDriver;
    }
    static getApiUrl() {
        return Orion.getHost() + Orion.getPrefix();
    }
    static setToken(token) {
        Orion.token = token;
        Orion.httpClientConfig = Orion.buildHttpClientConfig();
        return Orion;
    }
    static withoutToken() {
        Orion.token = null;
        Orion.httpClientConfig = Orion.buildHttpClientConfig();
        return Orion;
    }
    static getToken() {
        return Orion.token;
    }
    static getHttpClientConfig() {
        return this.httpClientConfig;
    }
    static setHttpClientConfig(config) {
        this.httpClientConfig = config;
        return Orion;
    }
    static makeHttpClient(baseUrl) {
        const client = this.makeHttpClientCallback
            ? this.makeHttpClientCallback()
            : axios.create();
        return new HttpClient(baseUrl || Orion.getApiUrl(), client);
    }
    static makeHttpClientUsing(callback) {
        this.makeHttpClientCallback = callback;
        return this;
    }
    static csrf() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.authDriver !== AuthDriver.Sanctum) {
                throw new Error(`Current auth driver is set to "${this.authDriver}". Fetching CSRF cookie can only be used with "sanctum" driver.`);
            }
            const httpClient = Orion.makeHttpClient();
            let response = null;
            try {
                response = yield httpClient
                    .getAxios()
                    .get(`sanctum/csrf-cookie`, { baseURL: Orion.getHost() });
            }
            catch (error) {
                throw new Error(`Unable to retrieve XSRF token cookie due to network error. Please ensure that SANCTUM_STATEFUL_DOMAINS and SESSION_DOMAIN environment variables are configured correctly on the API side.`);
            }
            const xsrfTokenPresent = document.cookie
                .split(';')
                .filter((cookie) => cookie.includes(httpClient.getAxios().defaults.xsrfCookieName || 'XSRF-TOKEN')).length > 0;
            if (!xsrfTokenPresent) {
                console.log(`Response status: ${response.status}`);
                console.log(`Response headers:`);
                console.log(response.headers);
                console.log(`Cookies: ${document.cookie}`);
                throw new Error(`XSRF token cookie is missing in the response. Please ensure that SANCTUM_STATEFUL_DOMAINS and SESSION_DOMAIN environment variables are configured correctly on the API side.`);
            }
        });
    }
    static buildHttpClientConfig() {
        const config = {
            withCredentials: Orion.getAuthDriver() === AuthDriver.Sanctum,
        };
        if (Orion.getToken()) {
            config.headers = {
                Authorization: `Bearer ${Orion.getToken()}`,
            };
        }
        return config;
    }
}
Orion.token = null;
Orion.makeHttpClientCallback = null;
//# sourceMappingURL=orion.js.map